import React, { useId } from 'react';
import { parseNumericInput } from '../format';

const NumberField = ({
  label,
  hint,
  suffix,
  value,
  onChange,
  optional = false,
  placeholder,
  min,
  max,
  step,
  invalid = false,
  errorMessage,
}) => {
  const id = useId();
  const errorId = `${id}-error`;

  const handleChange = (event) => {
    onChange(parseNumericInput(event.target.value));
  };

  return (
    <div className={`dg-field${invalid ? ' is-invalid' : ''}`}>
      <label className="dg-field-label" htmlFor={id}>
        {label}
        {optional ? (
          <span className="dg-field-optional">необязательно</span>
        ) : (
          <span className="dg-field-required" aria-hidden="true">
            *
          </span>
        )}
      </label>

      <div className="dg-field-control">
        <input
          id={id}
          className="dg-field-input"
          type="number"
          inputMode="decimal"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          aria-invalid={invalid || undefined}
          aria-describedby={invalid && errorMessage ? errorId : undefined}
        />
        {suffix ? <span className="dg-field-suffix">{suffix}</span> : null}
      </div>

      {invalid && errorMessage ? (
        <p className="dg-field-error" id={errorId}>
          {errorMessage}
        </p>
      ) : hint ? (
        <p className="dg-field-hint">{hint}</p>
      ) : null}
    </div>
  );
};

export default NumberField;
